import React from "react";
import Helmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

const RedirectPage = props => {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              siteUrl
            }
          }
        }
      `}
      render={data => {
        return (
          <Helmet
            htmlAttributes={{ lang: `en` }}
            title={props.pageContext.title}
            meta={[
              {
                name: `description`,
                content: props.pageContext.desc,
              },
              {
                property: `og:title`,
                content: props.pageContext.title,
              },
              {
                property: `og:description`,
                content: props.pageContext.desc,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:title`,
                content: props.pageContext.title,
              },
              {
                name: `twitter:description`,
                content: props.pageContext.desc,
              },
            ]}
          >
            <meta
              http-equiv="refresh"
              content={`0;url=${data.site.siteMetadata.siteUrl}${props.pageContext.redirect}`}
            />
          </Helmet>
        );
      }}
    />
  );
};

export default RedirectPage;
